import { createReducer, on } from '@ngrx/store';

import { SetWidgetTranslations } from '../actions';
import { intialWidgetState } from '../states/widgets.state';

export const WIDGET_REDUCER_KEY = 'widget';
export const WIDGET_REDUCER = createReducer(
    intialWidgetState,
    on(SetWidgetTranslations, (state, action) => {
        return {
            ...state,
            widgetTranslations: {
                ...state.widgetTranslations,
                [action.language]: {
                    ...state.widgetTranslations[action.language],
                    [action.widgetId]: action.translations,
                },
            },
        };
    })
);

